import mapboxgl from 'mapbox-gl';
import { colourScheme } from '../../../theme';
import MapHelpers from '../../map.utils';
import MapLayer from '../map-layer.enum';
import MapLayerManager from '../map-layer-manager.utils';
import MapLayerVisibility from '../map-layer-visibility.enum';

function addPolygonLayer(
  layer: MapLayer | string,
  paint: mapboxgl.FillPaint = {},
  groupLayerid?: string,
  drawingColour?: string,
  defaultOpacity: number = 0.3,
  drawingOpacity?: number
) {
  return new Promise((resolve) => {
    if (groupLayerid) {
      MapLayerManager.AddLayerinGroups(
        {
          id: layer,
          type: 'fill',
          source: layer,
          layout: {
            visibility: MapLayerVisibility.NOT_VISIBLE,
          },
          paint: {
            ...paint,
            'fill-color': drawingColour || colourScheme?.areaTint,
            'fill-opacity': drawingOpacity || defaultOpacity,
          },
        },
        [groupLayerid]
      );
    } else {
      MapHelpers.addLayer({
        id: layer,
        type: 'fill',
        source: layer,
        layout: {
          visibility: MapLayerVisibility.NOT_VISIBLE,
        },
        paint: {
          ...paint,
          'fill-color': drawingColour || colourScheme?.areaTint,
          'fill-opacity': drawingOpacity || defaultOpacity,
        },
      });
    }
    resolve(MapHelpers);
  });
}

export default addPolygonLayer;
